import { api } from '../../services/api'
import { showError, showSuccess } from '../misc/misc.actions'

export const updateKennelAssignment = (facility_id, kennel_id, updates) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY' })

		return api
			.patch(`/facility/${facility_id}/kennels/${kennel_id}`, updates)
			.then((response) => {
				dispatch({
					type: 'UPDATE_FACILITY_SUCCESS',
					payload: { kennels: response.data.kennels }
				})
				dispatch(showSuccess('Pet kennel assignment updated successfully.'))
			})
			.catch((error) => {
				dispatch(showError("An error occured while updating this pet's kennel assignment."))
				dispatch({ type: 'UPDATE_FACILITY_FAIL', payload: error })
			})
	}
}
export const updateFacilityKennels = (facilityId, kennels) => {
	return api
		.patch(`/facilities/${facilityId}`, { kennels })
		.then((response) => {
			return response.data
		})
		.catch((e) => {
			console.log(e)

			return null
		})
}

export const setSelectedKennelsFilters = (filters) => {
	return (dispatch) => {
		dispatch({ type: 'SET_SELECTED_KENNELS_FILTERS', payload: filters })
	}
}

export const setSelectedKennelFilters = (filters) => {
	return (dispatch) => {
		dispatch({ type: 'SET_SELECTED_KENNEL_FILTERS', payload: filters })
	}
}
